import { useMemo } from "react";

import { useCurrentEventChallenges } from "./useCurrentEventChallenges";
import { leaderboardUsers } from "../types/leaderboardUsersResponse";
import { useRealtimeDBLeaderboard } from "./useRealtimeLeaderboard";
import { Challenge } from "../types/challengeDataResponse";
import { WinnerResponse } from "../types/winnersResponse";
import { useWinners } from "./useChallengeWinnersData";

export type ClientProps = {
  leaderboard: {
    loading: boolean;
    data: leaderboardUsers[] | null;
    function: () => void;
    length: number;
  };

  winners: {
    loading: boolean;
    data: WinnerResponse[] | null;
    function: () => void;
  };

  challenge: {
    loading: boolean;
    data: Challenge | null;
    function: () => void;
  };

  nextChallenges: {
    loading: boolean;
    data: Challenge[] | null;
    function: () => void;
  };
  hasActiveChallenge: boolean;
};

export const useClientData = (client: string, previewMode?: boolean) => {
  console.log(previewMode);

  const previewModeData = {
    slug: "LOGITECH_FM_TEST-02-04-2024",
  };

  const {
    fetchUpcomingData,
    loadingNextChallenge,
    nextChallenges,
    fetchOngoingData,
    loadingOngoingChallenge,
    ongoingChallenge,
  } = useCurrentEventChallenges();

  const { fetchNewWinners, winnersData, loadingWinners } = useWinners(client);

  const { loadingRealtimeLeaderboard, leaderboardData, fetchAllLeaderboard } =
    useRealtimeDBLeaderboard({
      slug:
        previewMode === true ? previewModeData?.slug : ongoingChallenge?.slug,
    });

  const clientData = useMemo<ClientProps>(
    () => ({
      leaderboard: {
        loading: loadingRealtimeLeaderboard,
        data: leaderboardData,
        function: fetchAllLeaderboard,
        length: leaderboardData.length,
      },

      winners: {
        loading: loadingWinners,
        data: winnersData,
        function: fetchNewWinners,
      },

      challenge: {
        loading: loadingOngoingChallenge,
        data: ongoingChallenge,
        function: fetchOngoingData,
      },

      nextChallenges: {
        loading: loadingNextChallenge,
        data: nextChallenges,
        function: fetchUpcomingData,
      },
      hasActiveChallenge: !!ongoingChallenge?.slug,
    }),
    [
      loadingRealtimeLeaderboard,
      leaderboardData,
      loadingWinners,
      nextChallenges,
      winnersData,
      loadingOngoingChallenge,
      ongoingChallenge,
      fetchOngoingData,
      loadingNextChallenge,
      fetchUpcomingData,
    ]
  );

  return { clientData };
};
